// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* .nav{\n    flex-wrap: unset !important;\n    overflow: auto;\n    white-space: nowrap;\n} */", "",{"version":3,"sources":["webpack://./src/components/tabWidget/styles.css"],"names":[],"mappings":"AAAA;;;;GAIG","sourcesContent":["/* .nav{\n    flex-wrap: unset !important;\n    overflow: auto;\n    white-space: nowrap;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
